module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido12.41e3657d.svg";